import { Component, OnInit } from '@angular/core';
import { EndPointItem, EnvironmentService } from '../../../services/environment/environment.service';


@Component({
    selector: 'app-environment-settings',
    templateUrl: './environment-settings.component.html',
    styleUrls: ['./environment-settings.component.css'],
    standalone: false
})
export class EnvironmentSettingsComponent implements OnInit {
  selectedEngineEndpoint: EndPointItem;
  selectedAppEndpoint: EndPointItem;

  constructor(public environmentService: EnvironmentService) {
    this.selectedEngineEndpoint = this.environmentService.activeEngineEndpoint;
    this.selectedAppEndpoint = this.environmentService.activeAppEndpoint;
  }

  ngOnInit(): void {
  }

  onEngineEndpointSelected(item: EndPointItem): void {
    this.selectedEngineEndpoint = item;
    this.environmentService.setActiveEngineEndpoint(item);
  }

  onAppEndpointSelected(item: EndPointItem): void {
    this.selectedAppEndpoint = item;
    this.environmentService.setActiveAppEndpoint(item);
  }
}
